import { CatalogOtherCostVariableTypeEnum } from 'gql/graphql';
import type { ChoiceGroupDefaultItem } from 'uikit';

export const getVariableTypeChoiceLabel = ({ label }: ChoiceGroupDefaultItem): string => {
    if (label === CatalogOtherCostVariableTypeEnum.Simple) {
        return 'Простая';
    }
    if (label === CatalogOtherCostVariableTypeEnum.Composite) {
        return 'Составная';
    }

    return 'Ссылка';
};
